import {Component, OnInit, ViewChild} from '@angular/core';
import {SuppliersService} from '../../../../services/suppliers.service';
import {ActivatedRoute} from '@angular/router';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {SelectionModel} from '@angular/cdk/collections';
import {MultiEditPmStatusComponent} from './multi-edit-pm-status.component';
import {MatSort} from '@angular/material/sort';

@Component({
  selector: 'ps-pm-multi-project-status',
  templateUrl: 'pm-multi-project-status.component.html',
})
export class PmMultiProjectStatusComponent implements OnInit {
  selection: SelectionModel<PmProjectStatus>;
  pboName: string;
  displayedColumns: string[] = [
    'select',
    'pboPosName',
    'bmNr',
    'pboPosLinkName',
    'extPlannerText',
    'extMetrologistText',
    'kickoffDate',
    'latestReleaseConstDate',
    'latestReleaseSpecDate',
    'acceptanceDate',
    'productionProgress',
  ];
  dataSource: MatTableDataSource<PmProjectStatus>;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private suppliersService: SuppliersService,
    private route: ActivatedRoute,
    private matDialog: MatDialog,
  ) {}

  ngOnInit() {
    this.selection = new SelectionModel(true);
    this.refreshData();
  }

  refreshData() {
    if (this.route.snapshot.params.id) {
      this.suppliersService
        .getPmProjectStatusPositionsBulkedit(this.route.snapshot.params.id)
        .subscribe((result) => {
          this.pboName = result.pboName;
          this.dataSource = new MatTableDataSource<PmProjectStatus>(
            result.data,
          );
          this.dataSource.sort = this.sort;
          this.selection = new SelectionModel(true, []);
        });
    }
  }

  openEditDialog() {
    this.matDialog
      .open(MultiEditPmStatusComponent, {
        data: {
          pboPositions: this.selection.selected,
          pboId: this.route.snapshot.params.id,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        const data: PmProjectStatus[] = [];
        this.selection.selected.forEach((pos) => {
          data.push({
            ...result,
            pboPosId: pos.pboPosId,
          });
        });
        this.suppliersService
          .bulkEditPmProjectStatus(this.route.snapshot.params.id, data)
          .subscribe((result) => {
            this.refreshData();
          });
      });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected == numRows;
  }

  toggleAllRows() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }
}

export interface PmProjectStatus {
  pboPosId?: string;
  pboPosName?: string;
  pboPosLinkName?: string;
  pboPosLinkDescription?: string;
  latestReleaseSpecDate?: Date;
  latestReleaseConstDate?: Date;
  acceptanceDate?: Date;
  kickoffDate?: Date;
  extMetrologistId?: string;
  extMetrologistText?: string;
  extPlannerId?: string;
  extPlannerText?: string;
  productionProgress?: number;
  deliveryDate?: Date;
  bmNr?: string;
}
